import { render, staticRenderFns } from "./ScrollMenu.vue?vue&type=template&id=34ed5ac5&scoped=true&"
import script from "./ScrollMenu.vue?vue&type=script&lang=js&"
export * from "./ScrollMenu.vue?vue&type=script&lang=js&"
import style0 from "./ScrollMenu.vue?vue&type=style&index=0&id=34ed5ac5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ed5ac5",
  null
  
)

export default component.exports